import React from "react";

import image1 from "../../Assets/Images/why1.png";
import image2 from "../../Assets/Images/why2.png";
import image3 from "../../Assets/Images/why3.png";
import image4 from "../../Assets/Images/why4.png";
import secImage from "../../Assets/Images/MS2.png";

const cards = [
  { image: secImage, lines: ["SEC-", "Licensed"] },
  { image: image1, lines: ["Global and Unique Opportunities"], small: true },
  { image: image2, lines: ["Alternative", "Investments"] },
  { image: image3, lines: ["Dollar", "Investments"] },
  { image: image4, lines: ["Diversified", "Portfolio"] },
  { image: image2, lines: ["Shari’ah", "Compliance"] },
  { image: image3, lines: ["Superior", "Returns"] },
];

const Item = ({ image, lines, small }) => {
  return (
    <div className="flex flex-col bg-[#6935D3] justify-between  rounded-[18.67px] w-[260px] h-[200px] sm:w-[300px] sm:h-[220px] px-[26px] py-[26px] sm:px-[30px] sm:py-[30px] 2xl:w-[360px] 2xl:h-[250px] 3xl:w-[440px] 3xl:h-[330px] 2xl:px-[30px] 2xl:py-[40px] 4xl:w-[466.67px] 4xl:h-[369.33px] gap-3">
      <img
        src={image}
        alt=""
        className="w-[50px] h-[50px] 3xl:w-[70px] 3xl:h-[70px] 4xl:w-[88px] 4xl:h-[88px]"
      />
      <h2
        className={`text-[#FFF]  font-[700]  w-full text-[26px] sm:text-[28px] 2xl:text-[33px] leading-[32px] sm:leading-[34px] 2xl:leading-[36px] 3xl:leading-[57.6px] tracking-[-1%] ${
          small ? "3xl:text-[40px] 4xl:text-[46px]" : "3xl:text-[44px] 4xl:text-[48px]"
        }`}
      >
        {lines.map((line, i) => (
          <React.Fragment key={i}>
            {i > 0 && <br />}
            {line}
          </React.Fragment>
        ))}
      </h2>
    </div>
  );
};

// Time for one full set of cards to scroll past
const speed = 30000;

// The cards are rendered twice and the strip slides left by exactly one set
// (see .section in index.css), so it loops seamlessly on every screen width.
const CardSet = ({ hidden }) => (
  <div aria-hidden={hidden} className="flex gap-6 pr-6 sm:gap-10 sm:pr-10">
    {cards.map((card, i) => (
      <Item key={i} {...card} />
    ))}
  </div>
);

const WhyInvest = () => {
  return (
    <div className="2xl:min-h-[70vh] flex justify-end items-center bg-[#FFF] py-12 lg:py-[5%] w-full ">
      <div className="w-[98%] mx-auto overflow-hidden ">
        <div className=" px-[2.5%]">
          <h4 className=" font-[700] text-[#131E3D] mb-4 text-[34px] sm:text-[40px] lg:text-[54px] 3xl:text-[60px] 4xl:text-[64px] leading-[40px] sm:leading-[44px] lg:leading-[56px] 3xl:leading-[68.86px] 4xl:leading-[72.86px] ">
            Why Invest with Halvest?
          </h4>

          <div className="wrapper flex overflow-hidden ">
            <section
              className="flex section w-max my-6 sm:my-9 3xl:mt-12"
              style={{ "--speed": `${speed}ms` }}
            >
              <CardSet />
              <CardSet hidden />
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyInvest;
